export default {
	attributes: {
		design: 'basic',
		columns: 1,
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		showTestimonial: true,
		testimonial1: 'Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.',
		testimonialLineHeightUnit: 'em',
		testimonialTabletLineHeightUnit: 'em',
		testimonialMobileLineHeightUnit: 'em',
		showImage: true,
		imageShape: 'circle',
		imageSize: 'large',
		image1Id: 607,
		image1Url: 'https://source.unsplash.com/300x300/?selfie',
		image1Alt: 'Name',
		image1ShapeFlipX: false,
		image1ShapeFlipY: false,
		image1ShapeStretch: false,
		image2ShapeFlipX: false,
		image2ShapeFlipY: false,
		image2ShapeStretch: false,
		image3ShapeFlipX: false,
		image3ShapeFlipY: false,
		image3ShapeStretch: false,
		image1Size: 'large',
		image2Size: 'large',
		image3Size: 'large',
		showName: true,
		name1: 'Name',
		nameLineHeightUnit: 'em',
		nameTabletLineHeightUnit: 'em',
		nameMobileLineHeightUnit: 'em',
		showPosition: true,
		position1: 'Position',
		positionLineHeightUnit: 'em',
		positionTabletLineHeightUnit: 'em',
		positionMobileLineHeightUnit: 'em',
		uniqueClass: 'ugb-c5df9fa',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
